export default __webpack_public_path__ + "files/f9d11b5d4831f29245c8687b13b5b00e.woff2";